import React, { useState, useEffect } from 'react';
import {
  IN_ROOM_DINING_DISCOUNTS_EDIT,
  IN_ROOM_DINING_DISCOUNTS_TABS,
} from '../../../../../constants/InRoomDiningConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_SERVICES_IN_ROOM_DINING,
} from '../../../../../constants/RoleConsts';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import { selectedHotelCurrencySelector } from '../../../../property/propertySlice';
import { useSelector } from 'react-redux';
import { getCurrencyNameFromCode } from '../../../../../utils/commonUtils';
import { inRoomDiningDiscountsSelector } from '../../../servicesSlice';
import CustomChip from '../../../../../shared/form-controls/custom-chip/Custom-Chip';

const DiscountView = (props) => {
  const { discount, toggleDrawer, onViewToggle, hotelId, permissions } = props;
  const [tabValue, setTabValue] = useState(0);
  const [selectedDiscount, setSelectedDiscount] = useState({});
  const currency = useSelector(selectedHotelCurrencySelector);
  const inRoomDiningDiscount = useSelector(inRoomDiningDiscountsSelector);

  useEffect(() => {
    if (hotelId && discount.id && inRoomDiningDiscount.length) {
      const discountObj = {
        ...inRoomDiningDiscount.find((tempDiscountInfo) => tempDiscountInfo.id === discount.id),
      };
      setSelectedDiscount(discountObj);
    }
  }, [hotelId, discount, inRoomDiningDiscount]);

  const onClickEdit = (event) => {
    toggleDrawer(IN_ROOM_DINING_DISCOUNTS_EDIT, true, selectedDiscount);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderScreen = () => {
    return (
      <>
        {tabValue === 0 && (
          <>
            <div className='row mx-4 mt-4'>
              <div className='col-md-4'>
                <div className='details-label'>Discount Name</div>
                <div className='details-value preview-breaks'>{selectedDiscount.name}</div>
              </div>
              <div className='col-md-4'>
                <div className='details-label'>Discount Code</div>
                <div className='details-value'>{selectedDiscount.code}</div>
              </div>
              <div className='col-md-4'>
                <div className='details-label'>Status</div>
                <CustomChip
                  label={selectedDiscount.status ? 'Active' : 'Inactive'}
                  color={selectedDiscount.status ? 'primary' : 'default'}
                />
              </div>
            </div>
            <div className='row mx-4  mt-4'>
              <div className='col-md-4'>
                <div className='details-label'>Discount Value</div>
                <div className='details-value'>{selectedDiscount.value}%</div>
              </div>
              <div className='col-md-4'>
                <div className='details-label'>Maximum Discount</div>
                <div className='details-value'>
                  {getCurrencyNameFromCode(currency)} {selectedDiscount.upto}
                </div>
              </div>
            </div>
            <div className='row mx-4  mt-4'>
              <div className='col-md-12'>
                <div className='details-label'>Disclaimer</div>
                <div className='details-value'>
                  {selectedDiscount?.disclaimer ? selectedDiscount?.disclaimer : '---'}
                </div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-12'>
                <div className='details-label'>Description</div>
                <div className='details-value preview-breaks'>
                  {selectedDiscount?.description ? selectedDiscount?.description : '---'}
                </div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              {selectedDiscount?.customAttributes &&
                selectedDiscount?.customAttributes?.length > 0 &&
                selectedDiscount?.customAttributes?.map((item, index) => (
                  <div key={index} className='col-md-4 mt-4'>
                    <div className='details-label'>{item.key}</div>
                    <div className='details-value'>{item.value}</div>
                  </div>
                ))}
            </div>
          </>
        )}
        {tabValue === 1 && (
          <>
            {selectedDiscount.schedule?.always ? (
              <div className='row mx-4 mt-4'>
                <div className='col-md-6'>
                  <div className='details-value'>Always Active</div>
                </div>
              </div>
            ) : (
              <>
                <div className='row mx-4  mt-4'>
                  <div className='col-md-6'>
                    <div className='details-label'>Valid From</div>
                    <div className='details-value'>{selectedDiscount.schedule?.from?.date}</div>
                  </div>
                  <div className='col-md-6'>
                    <div className='details-label'>Time</div>
                    <div className='details-value'>{selectedDiscount.schedule?.from?.time}</div>
                  </div>
                </div>
                <div className='row mx-4 mt-4'>
                  <div className='col-md-6'>
                    <div className='details-label'>Valid Till</div>
                    <div className='details-value'>{selectedDiscount.schedule?.till?.date}</div>
                  </div>
                  <div className='col-md-6'>
                    <div className='details-label'>Time</div>
                    <div className='details-value'>{selectedDiscount.schedule?.till?.time}</div>
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </>
    );
  };

  return (
    <>
      {selectedDiscount && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          renderScreen={renderScreen}
          handleTabChange={handleTabChange}
          tabValue={tabValue}
          tabList={IN_ROOM_DINING_DISCOUNTS_TABS}
          onViewToggle={onViewToggle}
          title={selectedDiscount.name}
          createdUserId={selectedDiscount.createdBy}
          isEditable={
            permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
          }
          tabClass='col-md-3'
          isHeightIncluded={false}
        />
      )}
    </>
  );
};

export default DiscountView;
